<template>
    <div>
            <div class="row my-3">

              <div class="col col-md-12">
                <div class="form-group required">
                  <label class='control-label'>Дата диагностики</label>
                  <date-component  :disabled="isReadonly" v-model="date" />
                  <div class="invalid-msg" v-if="v$.date.$error">Введите корректную дату</div>
                </div>
              </div>

              <div class="col col-md-12">
                <div class="form-group required">
                    <component-input type="time" :disabled="isReadonly" v-model="time" id="time"  label="Время диагностики"/>
<!--                  <label class='control-label'>Время диагностики</label>-->
<!--                  <div><input class="form-control" id="time" v-model="time" /></div>-->
                  <div class="invalid-msg" v-if="v$.time.$error">Введите корректное время</div>
                </div>
              </div>

              <div class="col col-md-12">
                <div class="form-group required">
                  <component-input type="select2" 
                    :select2Options="organizationList"
                    :select2Settings="select2settings"
                    :required="true"
                    :disabled="isReadonly" v-model="organizationId" label="Организация"/>
                </div>
              </div>
            </div>

            <div>
              <div class="float-right d-flex">
                <template v-if="isApprove">
                  <div class="btn btn-outline mx-2 text-diagnostic disabled">Диагностика утверждена</div>
                </template>
                <button-component v-if="!isReadonly && !isApprove" class="btn btn-primary mx-2" v-on:click="save">Сохранить</button-component>
                <button-component kind="secondary" type="button" class="btn btn-default" v-on:click="close">Закрыть</button-component>
              </div>
             </div>

    </div>
</template>
<script>
import API from '../api/diagnostic'
import Constants from '../../../common/constants'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import DateComponent from "@/common/components/DateComponent"
import Inputmask from 'inputmask';
import ButtonComponent from "@/common/ui/ButtonComponent";
import ComponentInput from "@/common/components/ComponentInput";
import security from "../../../common/mixins/security";



const timeValidator = (value) => value === null || value === undefined || value === '' || new RegExp("^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$", "g").test(value);

export default {
  name: "DiagnosticDateEnter",
  props: {
    journalId:Number,
    dateDiagnostic:String,
    orgId:Number,
    isApprove:Boolean
  },
  components: {
      ComponentInput,
      ButtonComponent,
      DateComponent
  },
  mixins: [security],
  created() {
      if (this.dateDiagnostic) {
          this.date = this.dateDiagnostic;
          this.time = this.dateDiagnostic.substring(11, 16);
      }
    this.organizationId = this.orgId;
    console.log("--created");
    this.loadOrganizations();
    this.checkPermission(Constants.JournalDiagnosticEdit).then((response) => { this.isReadonly = !response.data });
  },
  mounted() {
    // ... используем
    var im = new Inputmask("99:99");
    im.mask(document.getElementById('time'));
  },
  data() {
    return {
      date: null,
      time: null,
      isReadonly: false,
      organizationId: null,
      organizationList: [],
      select2Settings: Constants.select2Settings,
    };
  },
  methods: {
    loadOrganizations() {
      console.log("-- loadOrganizations");
      API.loadOrganizations("").then((response) => {
        this.organizationList = response.data;
        //$("#selectOrganization").trigger("change");
      });
    },
    save() {
        var self = this;

        self.v$.$touch();
        if (self.v$.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error' );
          return;
        }

        var dateEnter = self.date + "T" + self.time + ":00";
        var data = {
            journalId: self.journalId,
            dateEnter: dateEnter,
            organizationId: self.organizationId
        };
        API.saveDiagnosticDateEnter(data).then(function (response) {
            Constants.alert.fire('Сохранение', response.data.message, response.data.success ? 'success' : 'error' );
            if(response.data.success) {
                self.$emit('save');
            }
        });
    },    
    close() {
      this.$emit('close');
    }
  },
  setup: () => ({ v$: useVuelidate() }),
  validations () {
    return {
        date: { required },
        time: { required, timeValidator },
        organizationId: { required }
    }
  }
}; 
</script>
<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';

.form-group.required .control-label:after { 
   content:"*";
   color:red;
}
.form-check.required .control-label:after { 
   content:"*";
   color:red;
}
.invalid-msg {
  color:red;
  font-size: 0.75rem;
}
.control-label{
    font-weight: 400 !important;
    color: $gray-dark;
    font-size: 16px;
}
.text-diagnostic {
  padding: 14px 32px;
  font-weight: 400;
  // color: $gray-dark;
  cursor: default;
}

@media (max-width: 1440px) {
    .text-diagnostic {
        padding: 8px 16px;
    }
}
</style>